var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"mypooq",attrs:{"id":"contents"}},[(_vm.isLiveTitle)?_c('div',{staticClass:"top-padding"},[_c('live-title')],1):(_vm.hasTitle)?_c('my-pooq-title'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath + _vm.componentKey,attrs:{"name":"myPooqContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }